import React, { useEffect } from "react";
import LegalPageLayout from "@/components/LegalPageLayout";

export default function Impressum() {
  useEffect(() => {
    document.title = "Impressum — Rodex Berlin";
  }, []);

  return (
    <LegalPageLayout title="Impressum" intro="Angaben gemäß § 5 TMG">
      <section>
        <h2>Anbieter</h2>
        <p>
          <strong>Rodex Berlin – Philipp J. Thoma</strong><br />
          Einzelunternehmen<br />
          Manteuffelstr. 76<br />
          10999 Berlin<br />
          Deutschland
        </p>
      </section>

      <section>
        <h2>Kontakt</h2>
        <p>
          Telefon: <a href="tel:+493034762216">030 34762216</a><br />
          E-Mail: <a href="mailto:info@rodex.berlin">info@rodex.berlin</a><br />
          Web: <a href="https://www.rodex.berlin">www.rodex.berlin</a>
        </p>
      </section>

      <section>
        <h2>Vertretungsberechtigter</h2>
        <p>Philipp J. Thoma</p>
      </section>

      <section>
        <h2>Umsatzsteuer-Identifikationsnummer</h2>
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
          <strong>DE456359930</strong>
        </p>
      </section>

      <section>
        <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
        <p>
          Philipp J. Thoma<br />
          Manteuffelstr. 76<br />
          10999 Berlin
        </p>
      </section>

      <section>
        <h2>Berufshaftpflichtversicherung</h2>
        <p>
          AXA Versicherung AG<br />
          Colonia-Allee 10–20<br />
          51067 Köln<br />
          Geltungsraum: Deutschland
        </p>
      </section>

      <section>
        <h2>EU-Streitschlichtung</h2>
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
          <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
            https://ec.europa.eu/consumers/odr/
          </a>.<br />
          Unsere E-Mail-Adresse finden Sie oben im Impressum.
        </p>
      </section>

      <section>
        <h2>Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>

      <section>
        <h2>Haftungsausschluss</h2>
        <h3>Haftung für Inhalte</h3>
        <p>
          Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
          Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als
          Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach
          den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
          Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
          Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
          Tätigkeit hinweisen.
        </p>

        <h3>Haftung für Links</h3>
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
          Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
          Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
          Seiten verantwortlich.
        </p>

        <h3>Urheberrecht</h3>
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen
          dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art
          der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
          Zustimmung des jeweiligen Autors bzw. Erstellers.
        </p>
      </section>

      <p className="text-xs text-slate-500 pt-6 border-t border-slate-200">
        Stand: 2025.
      </p>
    </LegalPageLayout>
  );
}
